export default __webpack_public_path__ + "static/media/liyide.910676da.webp";